const state = {
    // count_request: 0
}
const mutations = {
    // SET_COUNT_REQUEST: (state, value) => {
    //     state.count_request = value
    // }
}
const actions = {
    // setCountRequest({commit}, params) {
    //     state.count_request ++
    //     commit('SET_COUNT_REQUEST', state.count_request)
    // }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}